import type {ReactNode} from "react";
import type React from "react";
import {memo} from "react";

import {Text} from "../ui/text";
import type {ITextProps} from "../ui/text/types";

export type Props = {
    variant?: ITextProps["variant"];
    color?: ITextProps["color"];
    children: ReactNode;
};

const PreText: React.FC<Props> = ({children, variant = "md", color}) => {
    return (
        <Text color={color} variant={variant}>
            {process.env.IS_WEB ? <pre className="mt-0 mb-0">{children}</pre> : children}
        </Text>
    );
};

export default memo(PreText);
